import { render, staticRenderFns } from "./DeliveredModal.vue?vue&type=template&id=15435bc8&"
import script from "./DeliveredModal.vue?vue&type=script&lang=js&"
export * from "./DeliveredModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports